// import { Button } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";
// import dayjs from "dayjs";

// export const getColumns = (setSelectedSchedule, setOpenDeleteDialog) => [
//   {
//     field: "day",
//     headerName: "Day",
//     flex: 1,
//     minWidth: 120,
//   },
//   {
//     field: "time",
//     headerName: "Time",
//     flex: 1,
//     minWidth: 120,
//   },
//   {
//     field: "created_at",
//     headerName: "Created At",
//     flex: 1,
//     minWidth: 180,
//     valueFormatter: (params) => {
//       return params ? dayjs(params).format("DD-MM-YYYY hh:mm A") : "-";
//     },
//   },
//   {
//     field: "created_by",
//     headerName: "Created By",
//     flex: 1,
//     minWidth: 150,
//   },
//   {
//     field: "actions",
//     headerName: "Actions",
//     width: 120, // Increased from 100 to 120
//     sortable: false,
//     renderCell: (params) => (
//       <Button
//         variant="outlined"
//         size="small"
//         startIcon={<DeleteIcon />}
//         onClick={() => {
//           setSelectedSchedule(params.row);
//           setOpenDeleteDialog(true);
//         }}
//         sx={{
//           color: "#f44336",
//           borderColor: "#f44336",
//           "&:hover": {
//             borderColor: "#d32f2f",
//             backgroundColor: "rgba(244, 67, 54, 0.04)",
//           },
//           textTransform: "none",
//           fontSize: "12px",
//           minWidth: "80px", // Optional: ensures button has minimum width
//         }}
//       >
//         Delete
//       </Button>
//     ),
//   },
// ];

// ************************************************************************************

import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import dayjs from "dayjs";
import { Box, Tooltip, IconButton } from "@mui/material";

export const getColumns = (setSelectedSchedule, setOpenDeleteDialog, setOpenEditDialog, setOpenPreviewDialog , apiResponse ) => {
  return [
  {
    field: "group_name",
    headerName: "Group Name",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "time",
    headerName: "Time",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "created_at",
    headerName: "Created At",
    flex: 1,
    minWidth: 180,
    valueFormatter: (params) => {
      return params ? dayjs(params).format("DD-MM-YYYY hh:mm A") : "-";
    },
  },
  {
    field: "created_by",
    headerName: "Created By",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 200,
    sortable: false,
    renderCell: (params) => {
      return (
        <Box 
          sx={{ 
            display: "flex", 
            gap: 0.5,
            alignItems: "center",
            justifyContent: "flex-start",
            width: "100%",
            height: "100%",
            pl: 1,
          }}
        >
          {/* Preview Eye Icon - Always visible */}
          <Tooltip title="Preview">
            <IconButton
              size="small"
              onClick={() => {
                setSelectedSchedule(params.row);
                setOpenPreviewDialog(true);
              }}
              sx={{
                color: "#7152F3",
                "&:hover": {
                  backgroundColor: "rgba(113, 82, 243, 0.04)",
                },
              }}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          {/* Edit Button - Only show if allow_edit === 1 */}
          {params.row.allow_edit === 1 && (
            <Tooltip title="Edit">
              <IconButton
                size="small"
                onClick={() => {
                  setSelectedSchedule(params.row);
                  setOpenEditDialog(true);
                }}
                sx={{
                  color: "#4CAF50",
                  "&:hover": {
                    backgroundColor: "rgba(76, 175, 80, 0.04)",
                  },
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}

          {/* Delete Button - Only show if allow_delete === 1 */}
          {params.row.allow_delete === 1 && (
            <Tooltip title="Delete">
              <IconButton
                size="small"
                onClick={() => {
                  setSelectedSchedule(params.row);
                  setOpenDeleteDialog(true);
                }}
                sx={{
                  color: "#f44336",
                  "&:hover": {
                    backgroundColor: "rgba(244, 67, 54, 0.04)",
                  },
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      );
    },
  },
];
};